// extracted by mini-css-extract-plugin
module.exports = {"blogSharingWrapper":"style-module--blogSharingWrapper--2XRoR"};